import axios from 'axios';
import api from './api';
const BASE_URI = "/auth/subscription"
export const subscriptionService = {
    createSubscription: async (priceId: string) => {
        try {
            const response = await api.post(`${BASE_URI}/create/`, {
                price_id: priceId
            });
            return response.data;
      } catch (error: any) {
        console.error('Failed to create subscription:', error.message || error.response?.data );
          const errorCode = error.message_code || error.response?.data?.code;
          throw new Error(errorCode);
      }
    },

    cancelSubscription: async () => {
        try {
        const response = await api.post(`${BASE_URI}/cancel/`);
        return response.data;
      } catch (error: any) {
        console.error('Failed to cancel subscription:', error.message || error.response?.data );
          const errorCode = error.message_code || error.response?.data?.code;
          throw new Error(errorCode);
      }
    },

    getSubscriptionStatus: async () => {
        try {
            const response = await api.get(`${BASE_URI}/status/`);
            return response.data;
      } catch (error: any) {
            console.error('Error getting subcription status:', error.message || error.response?.data );
            const errorCode = error.message_code || error.response?.data?.code;
            throw new Error(errorCode);
      }
    },
    createCheckoutSession: async (pricing: string, period: string) => {
        try {
        const response = await api.post(`${BASE_URI}/create-checkout-session/`, {pricing: pricing, period: period});
        return response.data;
      } catch (error: any) {
          const errorCode = error.response?.data.message_code || error.response?.data?.code;  

          throw new Error(errorCode);
      }
    },
    getSessionStatus: async (sessionId: string) => {
        try {
            const response = await api.get(`${BASE_URI}/session-status/`, {
                params: {
                    session_id: sessionId
                }
            });
            return response.data;
          } catch (error: any) {
            console.error('Error getting Session status:', error.message || error.response?.data );
              const errorCode = error.message_code || error.response?.data?.code;
              throw new Error(errorCode);
        }   
    }
};

export default subscriptionService; 
